/**
 * Googleマップ
 */
export default class Gmap {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'Gmap';
    this.office = {lat: 35.688061927420144, lng: 139.80629315452168};
    this.map = null;
    this.elMap = document.getElementById('gmap');

    if (this.elMap) {
      this.init();
    }
  }

  /**
   * 初期化
   */
  init() {
    const key = 'AIzaSyDGp4ZhsO8N2c1BDRi5-ngnQTID2_tZksg';

    // googleマップのscriptタグ生成
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=initGmap`;
    script.setAttribute('async', 'async');
    script.setAttribute('defer', 'defer');
    document.getElementsByTagName('head')[0].appendChild(script);

    // コールバック
    window.initGmap = this.initGmap.bind(this);
  }

  /**
   * Googleマップ設定（コールバック）
   */
  initGmap() {
    // The map, centered at office
    this.map = new google.maps.Map(
      this.elMap, {
        zoom: 18,
        center: this.office,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControl: false,
        styles: []
      });

    this.setMarker(true);

    google.maps.event.addDomListener(window, "resize", this.resize.bind(this));
  }

  setMarker(isDrop) {
    if (this.marker) this.marker.setMap(null);

    // The marker, positioned at office
    this.marker = new google.maps.Marker({
      position: this.office,
      map: this.map,
      title: '映画館ストレンジャー',
      animation: isDrop ? google.maps.Animation.DROP : null,
    });
  }

  /**
   * リサイズ
   */
  resize() {
    this.setMarker(false);
  }

  /**
   * MatchMedia（メディアクエリ）による判別
   */
  getMatchMedia() {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  /**
   * 現在のデバイスを判別（ブラウザ幅）
   */
  setDevice() {
    return this.getMatchMedia() ? 'sp' : 'pc';
  }
}
